import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { SegmentedButtons, HelperText } from 'react-native-paper';
import { Language, useLanguage } from '../i18n';

export default function LanguageSwitch() {
  const { language, setLanguage } = useLanguage();
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);
  const changeLanguage = async (value: string) => {
    setSaving(true);
    setError(false);
    try { await setLanguage(value as Language); }
    catch { setError(true); }
    finally { setSaving(false); }
  };
  return (
    <View style={styles.container}>
      <SegmentedButtons
        value={language}
        onValueChange={changeLanguage}
        buttons={[
          { value: 'ja', label: '日本語', accessibilityLabel: '日本語に切り替える', disabled: saving },
          { value: 'en', label: 'English', accessibilityLabel: 'Switch to English', disabled: saving },
        ]}
      />
      {error && <HelperText type="error">Could not save language / 言語を保存できませんでした</HelperText>}
    </View>
  );
}
const styles = StyleSheet.create({ container: { marginVertical: 12 } });
